import script from "./ClientSegments.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSegments.vue?vue&type=script&setup=true&lang=js"

import "./ClientSegments.vue?vue&type=style&index=0&id=5c66e7eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c66e7eb"]])

export default __exports__